import api from './api';
import router from '../../router';

const pathRegex = /^\/apikey/;

const state = {
	error: null,
	apikeys: [],
};

const getters = {};

const mutations = {
	setError(state, { error }) {
		state.error = error;
	},

	setApikeys(state, apikeys) {
		state.apikeys = apikeys;
	},

	addApikey(state, apikey) {
		state.apikeys.push(apikey);
	},

	updateApikey(state, apikey) {
		const apikeyIndex = state.apikeys.findIndex((key) => key._id === apikey.id);
		if (apikeyIndex != -1) {
			state.apikeys[apikeyIndex].name = apikey.name;
			state.apikeys[apikeyIndex].comment = apikey.comment;
		}
	},

	setDeleted(state, { apikeyId, deleted }) {
		const apikey = state.apikeys.find((key) => key._id === apikeyId);
		if (apikey !== undefined) {
			apikey.deleted = deleted;
		}
	},
};

const actions = {
	async load({ commit }) {
		try {
			const apikeys = (await api.list()).data;
			commit('setApikeys', apikeys);
		} catch (err) {
			commit('setError', { error: err.response.data.message });
		}
	},
	async create({ commit }, apikey) {
		try {
			const result = await api.create(apikey);
			commit('addApikey', result.data);
			return result.data;
		} catch (err) {
			commit('setError', { error: err.response.data.message });
		}
	},
	async update({ commit }, apikey) {
		try {
			const result = await api.update(apikey);
			commit('updateApikey', apikey);
			return result;
		} catch (err) {
			commit('setError', { error: err.response.data.message });
		}
	},
	async delete({ commit }, apikeyId) {
		try {
			await api.delete(apikeyId);
			commit('setDeleted', { apikeyId, deleted: true });
		} catch (err) {
			commit('setError', { error: err.response.data.message });
		}
	},
	async restore({ commit }, apikeyId) {
		try {
			const result = await api.update({ id: apikeyId, deleted: false });
			commit('setDeleted', { apikeyId, deleted: false });
		} catch (err) {
			commit('setError', { error: err.response.data.message });
		}
	},
	clearError({ commit }) {
		commit('setError', { error: null });
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
